@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

$borderColor: v.$palette-gray-300;
$color: v.$palette-gray-900;
$hoverColor: v.$palette-blue;
$countColor: v.$palette-gray-600;

.button {
  font-family: v.$primary-font;
  user-select: none;
  background: v.$palette-white;
  border: 1px solid $borderColor;
  border-radius: 6px;
  padding: 5px 16px;
  @include t.text(14px, 22px, 600);
  color: $color;

  &:hover, &:focus {
    color: $hoverColor;
  }
}

.count {
  margin-left: 5px;
  color: $countColor;
}
